import { render, staticRenderFns } from "./KanbanPolicyRenewal.vue?vue&type=template&id=ec1fe22c&scoped=true"
import script from "./KanbanPolicyRenewal.vue?vue&type=script&lang=js"
export * from "./KanbanPolicyRenewal.vue?vue&type=script&lang=js"
import style0 from "./KanbanPolicyRenewal.vue?vue&type=style&index=0&id=ec1fe22c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec1fe22c",
  null
  
)

export default component.exports